export default "__VITE_ASSET__17baac52__"